module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage1.eb9ff2a4b676874795a5ea238b087d17.jpg";